import { apiSlice } from "../../Api/apiSlice";

const assignmentsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Get all assignments  records
    getAssignments: builder.query({
      query: () => "/assignments ",
    }),
    // Get one specific Assignment record
    getAssignment: builder.query({
      query: (aId) => `/assignments/${aId}`,
    }),
    // Add new Assignment
    addAssignment: builder.mutation({
      query: (data) => ({
        url: "/assignments",
        method: "POST",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(
            assignmentsApi.util.updateQueryData(
              "getAssignments",
              undefined,
              (draft) => {
                draft.push(data);
              }
            )
          );
        } catch (error) {
          console.log("Assignment Fetch Error: ", error.message);
        }
      },
    }),
    // Edit Assignment
    editAssignment: builder.mutation({
      query: ({ data, id }) => ({
        url: `/assignments/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, error, arg) => [
        { type: "assignment", id: arg.id },
      ],
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(
            assignmentsApi.util.updateQueryData(
              "getAssignments",
              undefined,
              (draft) => {
                const agn = draft.find((a) => a.id == data.id);
                Object.assign(agn, { ...data });
              }
            )
          );
        } catch (error) {
          console.log("Error assignment edit::", error.message);
        }
      },
    }),
    // Delete Assignment
    deleteAssignment: builder.mutation({
      query: (vId) => ({
        url: `/assignments/${vId}`,
        method: "DELETE",
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        // Optimistic cache update Start
        const patchResult = dispatch(
          assignmentsApi.util.updateQueryData(
            "getAssignments",
            undefined,
            (draft) => {
              return (draft = draft.filter((a) => a.id != arg));
            }
          )
        );
        queryFulfilled.catch(patchResult.undo);
        // Optimistic cache update End
      },
    }),
  }),
});

export const {
  useGetAssignmentQuery,
  useGetAssignmentsQuery,
  useAddAssignmentMutation,
  useEditAssignmentMutation,
  useDeleteAssignmentMutation,
} = assignmentsApi;
